export function followupDay(date) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date || "")) return "";
  const parsed = new Date(`${date}T12:00:00`);
  return Number.isNaN(parsed.getTime()) ? "" : parsed.toLocaleDateString("ar-SA", { weekday: "long" });
}

export function academicFollowups(data) {
  if (Array.isArray(data.followups)) return data.followups;
  return data.followup_date || data.followup || data.outcome
    ? [{ date: data.followup_date || "", notes: data.followup || "", result: data.outcome || "" }]
    : [];
}
